<template>
  <v-row>
    <v-col
      v-if="isLoading"
      cols="12"
      class="text-center"
    >
      <v-progress-circular
        :size="125"
        :width="10"
        color="primary"
        indeterminate
      />
    </v-col>
    <v-col
      v-if="!isLoading"
      cols="12"
    >
      <v-row>
        <v-col cols="12" xs="12" md="6">
          <subscription-customer-card
            :init-customer="subscription.customer"
            @customer-loaded="val => { customerObj = val}"
          />
        </v-col>
        <v-col cols="12" xs="12" md="6">
          <subscription-payment-method
            :init-customer="customerObj"
            @change-source="onChangeSource"
          />
        </v-col>
      </v-row>

      <subscription-service-basket
        :currency="'cad'"
        :init-subscription="subscription"
        @change-items="onChangeItems"
        @change-coupon="onChangeCoupon"
        @change-trial="onChangeTrial"
        @change-taxes="onChangeTaxes"
      />

      <v-divider class="my-5" />

      <v-btn
        rounded
        outlined
        class="mr-3"
        :disabled="isSendingApi"
      >
        Discard
      </v-btn>

      <v-btn
        rounded
        outlined
        color="primary"
        :disabled="isSendingApi"
        :loading="isSendingApi"
        @click="id ? onUpdateSubscription($event) : onCreateSubscription($event)"
      >
        {{ id ? 'Update' : 'Start' }} Subscription
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions } from 'vuex'
import SubscriptionCustomerCard from '@/components/Subscription/SubscriptionCustomerCard'
import SubscriptionServiceBasket from '@/components/Subscription/SubscriptionServiceBasket'
import SubscriptionPaymentMethod from '@/components/Subscription/SubscriptionPaymentMethod'

export default {
  components: {
    SubscriptionCustomerCard,
    SubscriptionServiceBasket,
    SubscriptionPaymentMethod
  },
  props: {
    // Subscription ID
    // If provided, we assume the user is editing
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      subscription: {},
      isLoading: false,
      isSendingApi: false,
      customerObj: {},
      model: {
        customer: this.$route.query.customer,
        items: [],
        coupon: null,
        trial_end: undefined,
        default_tax_rates: [],
        default_payment_method: null
      }
    }
  },
  async mounted() {
    if( this.id ) {
      /**
       * If an ID was provided, we need to do a fresh GET request for the subscription
       * because the "listSubscription" call does not allow us to expand the products in order
       * to get the name because it is 5 levels deep. Stripe only allows 4 levels deep.
       *
       * @todo - We can improve this by checking if the state contains the subscription with the
       *        "plan" field. This means the subscription only has 1 plan. In which case this plan
       *        will have the product field already expanded.
       */
      const payload =  {
        _reload: true, // see @/stores/helper.js
        expand: ['items.data.plan.product', 'customer' ],
        id: this.id
      }

      this.isLoading = true
      const sub = await this.getSubscription(payload)
        .finally(() => {
          this.isLoading = false
        })

      this.subscription = sub
    }
  },
  methods: {
    ...mapActions([ 'createSubscription', 'updateSubscription', 'getSubscription' ]),
    async onUpdateSubscription(event) {
      const customer = this.subscription.customer.id
      const payload = {
        ...this.model,
        id: this.id,
        customer
      }

      this.isSendingApi = true
      const sub = await this.updateSubscription(payload)
        .then(() => {
          this.$router.push({
            name: 'customer-detail',
            params: {
              id: customer
            }
          })
        })
        .finally(() => {
          this.isSendingApi = false
        })
    },
    async onCreateSubscription(event) {
      const payload = { ...this.model }

      this.isSendingApi = true
      const sub = await this.createSubscription(payload)
        .then(() => {
          this.$router.push({
            name: 'customer-detail',
            params: {
              id: this.$route.query.customer
            }
          })
        })
        .finally(() => {
          this.isSendingApi = false
        })
    },
    onChangeItems(items) {
      this.model.items = items.map(i => {

        return {
          id: i.subscriptionItem ? i.subscriptionItem.id : undefined,
          plan: i.id,
          quantity: i.quantity,
          deleted: i.deleted
        }
      })
    },
    onChangeCoupon(coupon) {
      this.model.coupon = coupon.id
    },
    onChangeTrial(trialEnd) {
      if (trialEnd) {
        this.model.trial_end = trialEnd
      }
    },
    onChangeTaxes(taxes) {
      this.model.default_tax_rates = taxes.map(t => t.id)
    },
    onChangeSource(source) {
      this.model.default_payment_method = source
    }
  }
}
</script>
